import * as actionTypes from './auditLogActionTypes';

const initialState = {
  auditLogs: [],
  loading: false,
  error: null,
  selectedBookingId: null
};

export const auditLogReducer = (state = initialState, action) => {
  switch (action.type) {
    // Fetch Audit Logs by Booking ID
    case actionTypes.FETCH_AUDIT_LOGS:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case actionTypes.FETCH_AUDIT_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        auditLogs: action.payload,
        error: null
      };
    
    case actionTypes.FETCH_AUDIT_LOGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Fetch Audit Logs by Type
    case actionTypes.FETCH_AUDIT_LOGS_BY_TYPE:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case actionTypes.FETCH_AUDIT_LOGS_BY_TYPE_SUCCESS:
      return {
        ...state,
        loading: false,
        auditLogs: action.payload,
        error: null
      };
    
    case actionTypes.FETCH_AUDIT_LOGS_BY_TYPE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Fetch Audit Logs by Date Range
    case actionTypes.FETCH_AUDIT_LOGS_BY_DATE_RANGE:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case actionTypes.FETCH_AUDIT_LOGS_BY_DATE_RANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        auditLogs: action.payload,
        error: null
      };
    
    case actionTypes.FETCH_AUDIT_LOGS_BY_DATE_RANGE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // Clear Audit Logs
    case actionTypes.CLEAR_AUDIT_LOGS:
      return {
        ...state,
        auditLogs: [],
        error: null
      };

    // Clear Error
    case actionTypes.CLEAR_AUDIT_LOG_ERROR:
      return {
        ...state,
        error: null
      };

    default:
      return state;
  }
};
